/*
Modulo que muestra cuadricula de items/articulos/gifts compuesto por [CardGift, TablePagination]
*/

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

// import { URL } from '../config'

// COMPONENTS
import CardGift from '../components/CardGift'
import TablePaginationActions from '../components/TablePaginationActions'

// #region CSS
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Grow from '@material-ui/core/Grow'
import CircularProgress from '@material-ui/core/CircularProgress'
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import FormControl from '@material-ui/core/FormControl'
import TableCell from '@material-ui/core/TableCell'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex'
  },
  progress: {
    marginTop: '200px'
  }
}))
// #endregion

export default function GridCardItem({ pagination, setPagination, loading, error, listItems, numOfItem, onClick, options }) {
  const classes = useStyles()
  const isntFilter = options ? (!!options.isntFilter) : false
  const isFidelizacion = options ? (!!options.isFidelizacion) : false
  const isInventario = options ? !!options.isInventario : false
  const isMobile = useMediaQuery('(max-width:500px)')
  const haveClient = options ? (!!options.haveClient) : false
  const haveMovement = options ? (!!options.haveMovement) : false

  // #region HandleChange
  const handleChange = prop => event => {
    setPagination({ ...pagination, order: event.target.value })
  }

  const handleChangePage = (event, newPage) => {
    setPagination({ ...pagination, page: newPage })
  }

  const handleChangeRowsForPage = event => {
    setPagination({
      ...pagination,
      page: 0,
      rowsForPage: parseInt(event.target.value, 10)
    })
  }
  // #endregion

  useEffect(() => {

  }, [loading])

  return (
    <div className={classes.container}>
      {loading ? (
        <Grid container spacing={2} direction='row' justify='center' alignItems='center'>
          <CircularProgress className={classes.progress} color='secondary' size={60} />
        </Grid>
      ) : error ? (
        <Grid container spacing={2} direction='row' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Box className={classes.text} textAlign='center'>
              <Typography data-lang="gift_error_server" color='secondary' variant='h6'>
                Hay un problema con el servidor, pruebe más tarde. Perdone las molestias.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      ) : listItems.length === 0 && isntFilter ? (
        <Grid container style={{ marginTop: '50px' }} direction='row' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Box className={classes.text} textAlign='center'>
              <Typography data-lang="gift_filter_to_view" color='secondary' variant='h5'>
                Filtrar para visualizar productos.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      ) : listItems.length === 0 ? (
        <Grid container style={{ marginTop: '50px' }} direction='row' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Box className={classes.text} textAlign='center'>
              <Typography data-lang="gift_no_results" color='secondary' variant='h5'>
                No se han encontrado, modifique el filtro.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      ) : isInventario ? (<Grid container spacing={2} direction='row' justify='center' alignItems='center'>
        {listItems.map((gift, index) => (
          <Grow key={index} in={true} style={{ transformOrigin: '0 0 0' }} {...(options ? (options.isFidelizacion ? {} : { timeout: index * 500 }) : { timeout: index * 500 })}>
            <Grid item xs={12} md={6} lg={isFidelizacion ? (haveClient || haveMovement ? 2 : 1) : 3} container justify='center' alignItems='center'>
              <CardGift gift={gift} onClick={onClick} options={options} />
            </Grid>
          </Grow>
        ))}
        <Grid item xs={11} md={4} container justify='center' alignItems='center'>
          <Grid>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={6} style={{ border: '0px' }}>
                    <FormControl>
                        <Select value={pagination.order} onChange={handleChange('order')}>
                          <MenuItem data-lang="gift_order_asc" value={0}>Puntos ascendiente</MenuItem>
                          <MenuItem data-lang="gift_order_desc" value={1}>Puntos descendiente</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Grid>
          </Grid>
          <Grid item xs={11} md={8} container justify='center' alignItems='center'>
            {isMobile ? (
              <TablePaginationActions count={numOfItem} page={pagination.page} rowsPerPage={pagination.rowsForPage} onChangePage={handleChangePage} />
            ) : (
              <Grid>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TablePagination
                        id='pagination'
                        style={{ border: '0px' }}
                        labelRowsPerPage={<span data-lang="gift_per_page">Regalos por página</span>}
                        rowsPerPageOptions={pagination.listNumRows}
                        count={numOfItem}
                        rowsPerPage={pagination.rowsForPage}
                        page={pagination.page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsForPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableHead>
                </Table>
              </Grid>
            )}
          </Grid>

      </Grid>) : (
        <Grid container spacing={2} direction='row' justify='center' alignItems='center'>
          <Grid item xs={11} md={4} container justify='center' alignItems='center'>
            <Grid>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={6} style={{ border: '0px' }}>
                      <FormControl>
                        <Select value={pagination.order} onChange={handleChange('order')}>
                          <MenuItem data-lang="gift_order_asc" value={0}>Puntos ascendiente</MenuItem>
                          <MenuItem data-lang="gift_order_desc" value={1}>Puntos descendiente</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </Grid>
          </Grid>
          <Grid item xs={11} md={8} container justify='center' alignItems='center'>
            {isMobile ? (
              <TablePaginationActions count={numOfItem} page={pagination.page} rowsPerPage={pagination.rowsForPage} onChangePage={handleChangePage} />
            ) : (
              <Grid>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TablePagination
                        id='pagination'
                        style={{ border: '0px' }}
                        labelRowsPerPage={<span data-lang="gift_per_page">Regalos por página</span>}
                        rowsPerPageOptions={pagination.listNumRows}
                        count={numOfItem}
                        rowsPerPage={pagination.rowsForPage}
                        page={pagination.page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsForPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableHead>
                </Table>
              </Grid>
            )}
          </Grid>
          {listItems.map((gift, index) => (
            <Grow key={index} in={true} style={{ transformOrigin: '0 0 0' }} {...(options ? (options.isFidelizacion ? {} : { timeout: index * 500 }) : { timeout: index * 500 })}>
              <Grid item xs={12} md={6} lg={isFidelizacion ? (haveClient || haveMovement ? 2 : 1) : 3} container justify='center' alignItems='center'>
                <CardGift gift={gift} onClick={onClick} options={options} />
              </Grid>
            </Grow>
          ))}
        </Grid>
      )}
    </div>
  )
}

GridCardItem.propTypes = {
  pagination: PropTypes.object.isRequired,
  setPagination: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  listItems: PropTypes.array.isRequired,
  numOfItem: PropTypes.number.isRequired,
  options: PropTypes.object
}
